<p>purse-list works!</p>
<div class="container">
   <div class="row">   
     <div class="col-md-2" *ngFor="let purse of purseList">
<app-purse-item [purseItem]="purse"  [addedToWishlist]="wishlist.indexOf(purse.id) >= 0"></app-purse-item> 
     </div>
   </div>  
 </div>     

